<template>
  <div class="log-settings">
    <main>

      <a-row style="padding:0 20px;">
        <a-form-model :model="sysCleanUpForm" :layout="formLayout"   ref="sysCleanUpForm"  style="margin-top: 15px;display: flex;flex-direction: column;">
          <a-col :span="7">
            <a-form-model-item label="是否启用" prop="screenRecord">
              <a-switch v-model="sysCleanUpForm.screenRecord" checked-children="开" un-checked-children="关"  @change="onchange"  />
            </a-form-model-item>
          </a-col>

          <a-col :span="7" v-if="sysCleanUpForm.screenRecord">
            <a-form-model-item label="流程日志清理" prop="jobLogClr" :rules="[{required: sysCleanUpForm.screenRecord, message: '流程日志清理天数不能为空'}]">
              <a-input-number
                  v-model="sysCleanUpForm.jobLogClr"
                  placeholder="请输入"
                  :min="1"
                  :max="365"
              />
              <label>(范围1~365)天</label>
            </a-form-model-item>
          </a-col>

          <a-col :span="7" v-if="sysCleanUpForm.screenRecord">
            <a-form-model-item label="审计日志清理" prop="auditLogClr" :rules="[{required: sysCleanUpForm.screenRecord, message: '审计日志清理天数不能为空'}]">
              <a-input-number
                  v-model="sysCleanUpForm.auditLogClr"
                  placeholder="请输入"
                  :min="1"
                  :max="365"
              />
              <label>(范围1~365)天</label>
            </a-form-model-item>
          </a-col>

          <a-col :span="7" v-if="sysCleanUpForm.screenRecord">
            <a-form-model-item label="录屏文件清理" prop="screenRecClr" :rules="[{required: sysCleanUpForm.screenRecord, message: '录屏文件清理天数不能为空'}]">
              <a-input-number
                  v-model="sysCleanUpForm.screenRecClr"
                  placeholder="请输入"
                  :min="1"
                  :max="365"
              />
              <label>(范围1~365)天</label>

            </a-form-model-item>
          </a-col>


          <a-col :span="24" class="sysSet-operate">

            <a-form-model-item >
              <a-button type="primary"  @click="settingsSubmit" :loading="submitLoad" style="color: #ffffff">
                保存
              </a-button>
            </a-form-model-item>


          </a-col>
        </a-form-model>
      </a-row>


    </main>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      loading: false,
      sysCleanUpForm:{
        screenRecord:false,
        jobLogClr:7,
        auditLogClr:7,
        screenRecClr:7
      },
      rowData:'',
      formLayout:"inline",
    };
  },
  methods: {
    // 监听开关
    onchange(val){
     if (val){
       this.sysCleanUpForm.jobLogClr = ''
       this.sysCleanUpForm.auditLogClr = ''
       this.sysCleanUpForm.screenRecClr = ''
     }
    },
    // 回显天数
    echoLogList(){
      this.axios
          .post('setting/getScreenSetting')
          .then((res) => {
            if (res.code === 200) {
              if (res.data.jobLogClr == '0'  || res.data.jobLogClr == ''){
                this.sysCleanUpForm.screenRecord = false
              }else{
                this.sysCleanUpForm.screenRecord = true
              }
              this.rowData = res.data
              this.sysCleanUpForm.jobLogClr = res.data.jobLogClr ? res.data.jobLogClr : 7
              this.sysCleanUpForm.auditLogClr = res.data.auditLogClr ?  res.data.auditLogClr : 7
              this.sysCleanUpForm.screenRecClr = res.data.screenRecClr ? res.data.screenRecClr : 7
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },


    // 保存
    settingsSubmit(){
      this.$refs.sysCleanUpForm.validate((valid) => {
        if (valid) {
          if (!this.sysCleanUpForm.screenRecord ){
            this.sysCleanUpForm.jobLogClr = 0
            this.sysCleanUpForm.auditLogClr =0
            this.sysCleanUpForm.screenRecClr = 0
          }
          // this.sysCleanUpForm.jobLogClr = String(this.sysCleanUpForm.jobLogClr)
          // this.sysCleanUpForm.auditLogClr =  String(this.sysCleanUpForm.auditLogClr)
          // this.sysCleanUpForm.screenRecClr = String(this.sysCleanUpForm.screenRecClr)
          this.axios
              .post('setting/updateScreenSetting',  this.sysCleanUpForm)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.echoLogList()
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

  },
  beforeMount() {
    this.echoLogList()
  },
};
</script>

<style lang="scss" scoped>
.log-settings {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;

    ::v-deep .ant-form-item-label{
      font-weight: 600;
      padding-bottom: 10px;
    }
    ::v-deep .ant-form-item-control-wrapper{
      margin-top: 3px;
    }
    ::v-deep  .ant-form-inline .ant-form-item-with-help{
      margin-bottom: -15px;
    }
    ::v-deep  .ant-input-number{
      width: 150px;
      margin-bottom: 10px;
    }
    ::v-deep .ant-form-item-children{
      label{
        margin-left: 10px;
        font-weight: 600;
      }
    }
    //::v-deep .ant-form-item-children{
    //  display: flex;
    //  span{
    //    margin-left: 10px;
    //    font-weight: 600;
    //  }
    //}
    //.ant-form-item{
    //  display: flex;
    //  align-items: center;
    //
    //
    //  ::v-deep .has-error .ant-form-explain, .has-error .ant-form-split{
    //    position: absolute;
    //  }
    //}
    .ant-col{
      margin: 20px 0px 0;
    }
    //按钮
    .sysSet-operate{
      text-align: right;
      margin: 380px 0 46px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }

  }
}
</style>
